var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1094 13.1666V12.3333C12.1094 10.9526 10.83 9.83331 9.25204 9.83331H6.96671C5.38871 9.83331 4.10938 10.9526 4.10938 12.3333V13.1666M10.1094 5.83331C10.1094 6.36375 9.89866 6.87245 9.52359 7.24753C9.14852 7.6226 8.63981 7.83331 8.10938 7.83331C7.57894 7.83331 7.07023 7.6226 6.69516 7.24753C6.32009 6.87245 6.10938 6.36375 6.10938 5.83331C6.10938 5.30288 6.32009 4.79417 6.69516 4.4191C7.07023 4.04403 7.57894 3.83331 8.10938 3.83331C8.63981 3.83331 9.14852 4.04403 9.52359 4.4191C9.89866 4.79417 10.1094 5.30288 10.1094 5.83331Z",
    stroke: "#9C4900",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersone);
export default __webpack_public_path__ + "static/media/Persone.fda1c82ab85683a9db5552992d85db70.svg";
export { ForwardRef as ReactComponent };